import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/profit-margin',
  component: () => import('../../routes/ProfitMargin.svelte'),
  card: {
    id: 'profit-margin',
    title: 'Profit Margin Calculator',
    description: 'Calculate gross, operating, and net profit margins from revenue, COGS, and expenses.',
    icon: 'monitoring',
    iconBgClass: 'bg-emerald-50',
    iconTextClass: 'text-emerald-600',
    href: '/profit-margin',
    category: 'Business',
  },
  seo: {
    title: 'Profit Margin Calculator – Gross, Operating & Net Margin Calculator',
    description: 'Free profit margin calculator. Calculate gross margin, operating margin, and net margin from revenue and expenses. Compare markup vs margin, see break-even revenue, and understand your business profitability.',
  },
};

export default meta;
